export default __webpack_public_path__ + "static/media/ContactInformation.8aec005c.svg";